import { useCallback, useState } from 'react';
import { purify } from '@vfit/shared/themes';
import { Button, ImageAtoms } from '@vfit/shared/atoms';
import { IErrorProps } from './errorGeneric.models';
import * as S from './errorGeneric.style';

const ErrorGeneric: React.FC<IErrorProps> = ({
  title,
  subtitle,
  description,
  descriptionOnTop,
  action,
  actionText,
  customAction,
  customActionText,
  icon,
  variant = 'sunrise',
  hideTitle,
  isButtonSticky,
}) => {
  const [disabled, setDisabled] = useState(false);

  const handleAction = useCallback(() => {
    setDisabled(true);
    action?.();
  }, [action]);

  const handleCustomAction = useCallback(() => {
    setDisabled(true);
    customAction?.();
  }, [customAction]);

  const [pDescription, pSubtitle, pTitle] = purify([description, subtitle, title]);

  return (
    <S.Container>
      <S.MessageDiv>
        <S.TopContainer isButtonSticky={isButtonSticky}>
          {!hideTitle && pTitle && (
            <S.Title variant={variant} dangerouslySetInnerHTML={{ __html: pTitle }} />
          )}
          {icon && (
            <S.ImageContainer>
              <S.ImageWrapper>
                <ImageAtoms image={icon} nameCard="iconError" style={{ objectFit: 'contain' }} />
              </S.ImageWrapper>
            </S.ImageContainer>
          )}
          <S.BodyWrap descriptionOnTop={descriptionOnTop} variant={variant}>
            {pSubtitle && (
              <S.Subtitle variant={variant} dangerouslySetInnerHTML={{ __html: pSubtitle }} />
            )}
            {pDescription && (
              <S.Description variant={variant} dangerouslySetInnerHTML={{ __html: pDescription }} />
            )}
          </S.BodyWrap>
        </S.TopContainer>

        {(actionText || customActionText) && (
          <S.InsideButtonContainer variant={variant} isButtonSticky={isButtonSticky}>
            {actionText && (
              <Button
                variant={variant === 'mva' ? 'mva:primary' : 'primary'}
                onClick={handleAction}
                disabled={disabled}
              >
                {actionText}
              </Button>
            )}
            {customActionText && (
              <Button
                variant={variant === 'mva' ? 'mva:alt1' : 'secondary'}
                onClick={handleCustomAction}
                disabled={disabled}
              >
                {customActionText}
              </Button>
            )}
          </S.InsideButtonContainer>
        )}
      </S.MessageDiv>
    </S.Container>
  );
};

export default ErrorGeneric;

